import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import Swiper, { SwiperOptions } from 'swiper';
import { RestService } from 'src/app/service/rest.service';
import { SwiperComponent } from "swiper/angular";
import { Router } from '@angular/router';
import { FacultyService } from 'src/app/service/faculty.service';
import { SeoService } from 'src/app/service/seo.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  newsArr;
  faculty_count = 0
  newsArr2 = [];
  Researches;
  events
  faucltyArr:any = [];
  gradution_arr
  graduatesList:any[] = []
  gallery
  // Institutes carousel: horizontal card slider (no loop → no cloned slides, so
  // each card keeps its Angular click/keyboard handlers). Autoplay resets to the
  // first slide at the end without needing loop mode.
  instituteCardsConfig: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 24,
    freeMode: true,
    grabCursor: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: ".institutes-pagination",
      clickable: true,
    },
  };
  gradConfig: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".graduates-pagination",
      clickable: true,
    },
  };
  eventConfig: SwiperOptions = {
    slidesPerView: "auto",
      spaceBetween: 28,
      freeMode: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
  };
  galley_Config: SwiperOptions = {
    slidesPerView: 2,
      spaceBetween: 0,
      freeMode: true,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
  };
  galleryConfig: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    centeredSlides: false,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".gallery-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  };
  mangerConfig: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 30,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  }
  facultyMainTech:any[] = []
  facultyTechGroup
  techDetails:any = {}
  IS_REGISTRATION_OPEN = false
  constructor(private rest: RestService ,
    private facultyService: FacultyService,
    private seo: SeoService,
    private route : Router) { }

  ngOnInit() {
    this.setSeo()
    this.menu()
    this.homeapi()
    this.getBranch()
  }

  // Home is institute-specific (resolved from the subdomain), so title the page
  // with the institute name rather than the generic site title. On the main
  // academy host, getFacultyIDAndName() falls back to a single institute, so
  // title with the academy name instead. It's a landing page, so og:type = website.
  private setSeo() {
    const isAcademy = this.rest.isAcademyHost()
    const name = isAcademy
      ? 'أكاديمية الفنون'
      : this.rest.getFacultyIDAndName().FACULTY_NAME
    this.seo.update({
      // On the academy host the title *is* the academy name; passing it as the
      // page title would duplicate it (SeoService appends the site name), so
      // omit it there and let SeoService use the site name on its own.
      title: isAcademy ? undefined : name,
      description: isAcademy
        ? 'أكاديمية الفنون — الموقع الرسمي. الأخبار والفعاليات والدراسات والتقديم.'
        : `${name} بأكاديمية الفنون — الموقع الرسمي. الأخبار والفعاليات والدراسات والتقديم.`,
      type: 'website'
    })
  }

  ngAfterViewInit() {
    this.updateHeaderHeight()
    setTimeout(() => this.updateHeaderHeight(), 500)
  }

  @HostListener('window:resize')
  onResize() {
    this.updateHeaderHeight()
  }

  private updateHeaderHeight() {
    const header = document.querySelector('header.home-header') as HTMLElement
    if (header) {
      document.documentElement.style.setProperty('--home-header-h', header.offsetHeight + 'px')
    }
  }

  getBranch() {
    this.rest.getbranch().subscribe((res: any) => {
      console.log("branches",res)
      this.IS_REGISTRATION_OPEN = res.IS_REGISTRATION_OPEN
      localStorage.setItem('myArray', JSON.stringify(res));
    })
  }
  
  Vission
  Academy_president_name
  Academy_president_img
  Academy_Vice_president_name
  Academy_Vice_president_img
  Academy_Vice_president_about
  Academy_president_about
  misson
  goals
  massege : ''
  homeapi() {
    this.rest.homePage().subscribe((res: any) => {
      console.log("home", res)
      this.Vission = res.Vission
      this.Academy_president_name = res.Academy_president_name
      this.Academy_president_img = res.Academy_president_img
      this.Academy_Vice_president_name = res.Academy_Vice_president_name
      this.Academy_Vice_president_img = res.Academy_Vice_president_img
      this.Academy_Vice_president_about = res.Academy_Vice_president_about
      this.Academy_president_about = res.Academy_president_about
      this.newsArr2.push(res.News[0])
      this.newsArr = res.News
      this.newsArr.splice(0,1)
      this.Researches = res.Researches
      this.events = res.Events
      this.faucltyArr = this.rest.orderFaculties(res.faculty)
      this.faculty_count = res.faculty.length
      this.gradution_arr = res.graduates
      this.graduatesList = (res.graduates || []).reduce((acc, g) => acc.concat(g.graduates || []), [])
      this.gallery = res.gallery
      this.misson = res.mission
      this.goals = res.goals
      this.massege = res.message
    })

    this.facultyService.GetAllTeachingMembers().subscribe((res: any) => {
      console.log("instractors",res)
      this.facultyTechGroup = res.teachingmembersGroup
      this.facultyMainTech.push(res.academyPresident)
      this.facultyMainTech.push(res.academyVicePresident)
      res.facultyDeans.forEach(element => {
        this.facultyMainTech.push(element)
      });
    })
  }
  techData(id){
    this.facultyService.getTechDteails(id).subscribe(res => {
      console.log(res)
      this.techDetails = res
    })
  }
  scroolDowen(elemnt_id){
    document.getElementById(elemnt_id).scrollIntoView()
  }

  
  newsDetails(id){
    this.route.navigate(['/news_details',id])
  }

  eventDetails(id){
    this.route.navigate(['/event_Details',id])
  }

  Details(item){
    this.route.navigate(['/research_details',item.ID])
  }
  
  menu(){
    var scrollpos = window.scrollY;
    var nav = document.getElementsByClassName("main-nav-container")[0];

    function add_class_on_scroll() {
      nav.classList.add("bg-white");
    }

    function remove_class_on_scroll() {
      nav.classList.remove("bg-white");
    }

    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY;
      var intFrameHeight = window.innerHeight - 100;
      if (scrollpos > intFrameHeight) {
        add_class_on_scroll();
      }
      else {
        remove_class_on_scroll();
      }
    });

    
  }

  go_to_faculty(item){
    console.log(item)
    localStorage.setItem('FACULTY_NAME', item.FACULTY_NAME)
    localStorage.setItem("facultyId",item.ID)
    this.route.navigate(['/faculty',item.ID])
  }

  // Opens an institute's own subdomain site (e.g. hita.aoa.edu.eg).
  openInstitute(item){
    this.rest.openFacultySite(item)
  }

  // Delegated on the institutes swiper container: Swiper re-parents/clones the
  // projected slides, which drops per-slide Angular (click) listeners, so we
  // resolve the clicked card back to its faculty via the data-id attribute.
  onInstituteClick(event){
    const card = (event.target as HTMLElement).closest('.institute-card')
    if (!card) { return }
    const id = card.getAttribute('data-id')
    const item = (this.faucltyArr || []).find(f => String(f.ID) === String(id))
    if (item) { this.openInstitute(item) }
  }
  src_image:any = ''
  openImage(src){
    this.src_image = src
  }

  // Delegated on the swiper container so it also catches clicks on looped clone
  // slides (Swiper clones them with cloneNode, which drops Angular listeners).
  onGalleryClick(event){
    const card = (event.target as HTMLElement).closest('.gallery-card')
    const img = card && card.querySelector('img')
    if (img) {
      this.src_image = (img as HTMLImageElement).src
    }
  }

}
